mutation DELETE_TEAM_MEMBER($id: UUID!) {
  deleteTeamMember(id: $id) {
    success
    error
  }
}
